import {
    EquipoLogisticaDTO,
    MaterialesSomacylDTO,
    SomacylEntregablesDTO,
    validateAndFormatData
} from "sigo-entities";
import { IBodySomacyl } from "../../../../../Operaciones/OrdenesSomacyl/AddInventory";
import { indexedDB } from "../../../useIndexedDB";

export async function helperAddInventory(
    body: IBodySomacyl,
    _id: string,
    ownPersonal: boolean,
    getTransitSomacylOrdersQuery: (ID_Stock: number) => Promise<{ transito: number; }>
) {
    const doc = await indexedDB.somacyl_orders.get(_id)
    if (!doc) throw new Error('Documento no encontrado')

    // if (doc.inventory.length > 0) {
    //     throw new Error(`La orden ya tiene inventario`)
    // }

    let disponible = 0
    let itemCodigo = ''

    if (ownPersonal) {
        const stockPersonal = await indexedDB.stock_personal.get(body.ID_Stock)
        if (!stockPersonal) throw new Error('Stock personal no encontrado')
        const { transito } = await getTransitSomacylOrdersQuery(body.ID_Stock)
        const { Despacho, Devolucion, Liquidacion } = stockPersonal
        disponible = Despacho - Devolucion - Liquidacion - transito
        itemCodigo = stockPersonal.Item.Codigo
    } else {
        const stockAlmacen = await indexedDB.stock_almacen.get(body.ID_Stock)
        if (!stockAlmacen) throw new Error('Stock almacén no encontrado')
        const { transito } = await getTransitSomacylOrdersQuery(body.ID_Stock)
        const { Ingreso, Despacho, Devolucion, Liquidacion } = stockAlmacen
        disponible = Ingreso + Devolucion - Despacho - Liquidacion - transito
        itemCodigo = stockAlmacen.Item.Codigo
    }

    if (body.cantidad > disponible) {
        throw new Error(`Cantidad supera lo disponible`)
    }

    const item = await indexedDB.items_españa.get({ Codigo: itemCodigo })
    if (!item) throw new Error('Item no encontrado')

    const invpool = 'install'
    const dtos: MaterialesSomacylDTO[] = []
    const _dto = {
        cantidad: body.cantidad,
        codigo: item.Codigo,
        descripcion: item.Descripcion,
        invpool,
        invsn: '',
        ID_Stock: body.ID_Stock
    }
    const _entregables = new SomacylEntregablesDTO()
    _entregables.calibre_contador_nuevo = item.Calibre
    _entregables.codigo = item.Codigo
    _entregables.descripcion = item.Descripcion
    _entregables.latitud = body.latitud
    _entregables.lectura_contador_retirado = body.lecturaContadorRetirado
    _entregables.lectura_contador_instalado = body.lecturaContadorInstalado
    _entregables.longitud = body.longitud
    _entregables.observaciones = body.observaciones
    _entregables.tecnologia = item.Tecnologia

    let equipoStockPersonal: EquipoLogisticaDTO | null = null
    let equipoStockAlmacen: EquipoLogisticaDTO | null = null

    if (item.Ind_SB === 'S') {
        if (!body.Serie) {
            throw new Error(`Se requiere la serie`)
        }
        _dto.invsn = body.Serie

        if (ownPersonal) {
            const { equipo } = await selectStockPersonalEquipos(body.ID_Stock, body.Serie)

            _entregables.num_serie_contador_nuevo = body.Serie
            _entregables.marca_contador_nuevo = equipo.Marca
            _entregables.modelo_contador_nuevo = equipo.Modelo

            equipo.Estado = {
                ID_Estado: 13,
                Nombre: 'RESERVADO_CONSUMO'
            }
            equipo.Validado.Fecha = new Date()
            equipo.NroDocumento = doc.numero_de_peticion

            equipoStockPersonal = equipo
        } else {
            const { equipo } = await selectStockAlmacenEquipos(body.ID_Stock, body.Serie)

            _entregables.num_serie_contador_nuevo = body.Serie
            _entregables.marca_contador_nuevo = equipo.Marca
            _entregables.modelo_contador_nuevo = equipo.Modelo

            equipo.Estado = {
                ID_Estado: 13,
                Nombre: 'RESERVADO_CONSUMO'
            }
            equipo.Validado.Fecha = new Date()
            equipo.NroDocumento = doc.numero_de_peticion

            equipoStockAlmacen = equipo
        }
    }

    if (body.SerieDeinstall) {
        const _dto = {
            cantidad: 1,
            codigo: body.SerieDeinstall.Codigo,
            descripcion: body.SerieDeinstall.Descripcion,
            invpool: 'deinstall',
            invsn: body.SerieDeinstall.Serie,
            ID_Stock: Date.now(),
        }
        const dto = await validateAndFormatData(_dto, MaterialesSomacylDTO)
        dtos.push(dto)
    }

    const dto = await validateAndFormatData(_dto, MaterialesSomacylDTO)
    if (doc.inventory.some(e => e.ID_Stock === dto.ID_Stock && e.invsn === dto.invsn)) {
        throw new Error(`Inventario con stock personal ${dto.ID_Stock} ya existe en esta orden ${doc.numero_de_peticion}`)
    }
    dtos.push(dto)

    const entregables = await validateAndFormatData(
        _entregables,
        SomacylEntregablesDTO
    )

    const { valido, errores } = verifyInventory([...dtos, ...doc.inventory])

    if (!valido) {
        throw new Error(`Se excedió la cantidad máxima permitida ${errores.join(', ')}`)
    }

    await indexedDB.transaction(
        'rw',
        indexedDB.somacyl_orders,
        indexedDB.stock_personal_equipos,
        indexedDB.stock_almacen_equipos,
        async () => {

            // actualizar order
            doc.inventory = doc.inventory.concat(dtos)
            doc.entregables = entregables

            await indexedDB.somacyl_orders.put({
                ...doc,
                pendingSync: 1,
                updatedAt: Date.now()
            })

            if (item.Ind_SB === 'S') {
                if (ownPersonal) {

                    if (!equipoStockPersonal) {
                        throw new Error('Equipo stock personal no encontrado')
                    }

                    const row = await indexedDB.stock_personal_equipos.get({
                        ID_StockPersonal: body.ID_Stock
                    })

                    if (!row) {
                        throw new Error('Stock personal equipos no encontrado')
                    }

                    row.Equipos = row.Equipos.map((e) =>
                        e.Serie === equipoStockPersonal?.Serie
                            ? equipoStockPersonal
                            : e
                    )

                    await indexedDB.stock_personal_equipos.put(row)

                } else {

                    if (!equipoStockAlmacen) {
                        throw new Error('Equipo stock almacen no encontrado')
                    }

                    const row = await indexedDB.stock_almacen_equipos.get({
                        ID_StockAlmacen: body.ID_Stock
                    })

                    if (!row) {
                        throw new Error('Stock almacen equipos no encontrado')
                    }

                    row.Equipos = row.Equipos.map((e) =>
                        e.Serie === equipoStockAlmacen?.Serie
                            ? equipoStockAlmacen
                            : e
                    )

                    await indexedDB.stock_almacen_equipos.put(row)
                }
            }
        }
    )

    return await indexedDB.somacyl_orders.get(_id)
}

function verifyInventory(inventory: MaterialesSomacylDTO[]) {
    const limites: Record<string, number> = {
        CONTADOR: 2, // Ya que al agregar un contador se agrega automaticamente su material desinstalado
        LLAVE: 2,
        VALVULA: 2,
        TES: 1,
        TAPON: 1
    }

    const conteo: Record<string, number> = {};

    for (const material of inventory) {
        const descripcion = material.descripcion.toUpperCase()

        for (const tipo of Object.keys(limites)) {
            if (descripcion.includes(tipo)) {
                conteo[tipo] = (conteo[tipo] || 0) + material.cantidad;
            }
        }
    }

    const errores: string[] = [];

    for (const tipo of Object.keys(limites)) {
        if ((conteo[tipo] || 0) > limites[tipo]) {
            errores.push(
                `${tipo}: máximo ${limites[tipo]}, encontrado ${conteo[tipo]}`
            )
        }
    }

    return {
        valido: errores.length === 0,
        errores
    };
}

async function selectStockPersonalEquipos(ID_Stock: number, Serie: string) {
    const row = await indexedDB.stock_personal_equipos.get({ ID_StockPersonal: ID_Stock })
    if (!row) {
        throw new Error(`No se pudo obtener stock personal equipos`)
    }
    row.Equipos = row.Equipos.filter((e) => e.Serie === Serie)
    if (row.Equipos.length !== 1) {
        throw new Error(`No se pudo obtener stock personal equipos, hay ${row.Equipos.length} registros en Equipos con Serie ${Serie}`)
    }
    if (row.Equipos[0].Estado.ID_Estado !== 2) {
        throw new Error(`El equipo no está en estado disponible`)
    }
    return { stockPersonalEquipos: row, equipo: row.Equipos[0] }
}

async function selectStockAlmacenEquipos(ID_Stock: number, Serie: string) {
    const row = await indexedDB.stock_almacen_equipos.get({ ID_StockAlmacen: ID_Stock })
    if (!row) {
        throw new Error(`No se pudo obtener stock almacen equipos`)
    }
    row.Equipos = row.Equipos.filter((e) => e.Serie === Serie)
    if (row.Equipos.length !== 1) {
        throw new Error(`No se pudo obtener stock almacen equipos, hay ${row.Equipos.length} registros en Equipos con Serie ${Serie}`)
    }
    if (row.Equipos[0].Estado.ID_Estado !== 2) {
        throw new Error(`El equipo no está en estado disponible`)
    }
    return { stockAlmacenEquipos: row, equipo: row.Equipos[0] }
}